var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Box, Space, Label, TextHeading } from '@ally/metronome-ui';
export const InputRow = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Box, Object.assign({ display: "flex", width: "12" }, rest), children));
};
/**
 * A `Box` used to lay out standard form fields
 *
 * Has width of [12, 12, 12, 8, 6]
 *
 * Display of `flex`
 *
 * Margin-bottom of `"md"`
 */
export const FormField = (_a) => {
    var { children, flexDirection = 'column', isInPortal = false } = _a, rest = __rest(_a, ["children", "flexDirection", "isInPortal"]);
    return (React.createElement(Box, Object.assign({ width: isInPortal ? 12 : [12, 12, 12, 8, 6], flexDirection: flexDirection, display: "flex", mb: "md" }, rest), children));
};
export const FormLabel = ({ htmlFor, children, }) => {
    return (React.createElement(Label, { htmlFor: htmlFor, mb: "xxs" }, children));
};
/**
 * The `skip-target` id is used to provide a landing point from a `Skip to main content` button.
 */
export const LoginHeading = ({ title, isInPortal = false, focusOnMount = true, dataAnchorId = 'heading', }) => {
    return (React.createElement(Space, { mb: "md" },
        React.createElement(TextHeading, { focusOnMount: focusOnMount, tag: isInPortal ? 'h2' : 'h1', size: "md", id: "skip-target", tabIndex: -1, "data-anchor-id": dataAnchorId }, title)));
};
//# sourceMappingURL=Layout.js.map